import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import Input from '@components/@core/Input';
import Pagination from '@components/@core/Pagination';

const Header = () => (
    <div className="d-flex border-bottom pb-3 desktop-screen">
        <div className="d-flex-4">
            <span className="dsl-m12">User</span>
        </div>
        <div className="d-flex-4 text-end">
            <span className="dsl-m12">Default Company</span>
        </div>
        <div className="d-flex-3 text-end">
            <span className="dsl-m12">Profile optimized</span>
        </div>
        <div className="d-flex-2 text-end">
            <span className="dsl-m12">HCM</span>
        </div>
        <div className="d-flex-3 text-end">
            <span className="dsl-m12">Active logins</span>
        </div>
        <div className="d-flex-3 text-end">
            <span className="dsl-m12">Last login</span>
        </div>
        <div className="w50" />
    </div>
);

const All = ({ users, onChange, onSelect }) => {
    const [search, setSearch] = useState('');

    const handlePage = (e) => {
        onChange({ page: e, per_page: 20 });
    };

    const handleSearch = (e) => {
        onChange({ search: e, page: 1, per_page: 20 });
        setSearch(e);
    };

    return (
        <>
            <div className="d-flex jc-between ssm-column my-4">
                <div className="d-flex ssm-column ai-start">
                    <Input className="ml-0" placeholder="Search here..." value={search} onChange={handleSearch} />
                    <Button className="ml-4 ssm-l-0 ps-3 ssp-l-0" name="SEARCH" type="link" />
                </div>
            </div>
            <Header />
            {users.data.map((item) => {
                const name = `${item.first_name} ${item.last_name}`;
                const isBanded = item.profile?.banned ?? false;
                const options = ['Add user', `${isBanded ? 'Restore user' : 'Block user'}`, 'Edit'];
                let completion = 0;
                if (item.first_name && item.last_name && name !== '') completion += 20;
                if (item.avatar && item.avatar !== '') completion += 20;
                if (item.email && item.email !== '') completion += 20;
                if (item.profile?.job_title && item.profile?.job_title !== '') completion += 20;
                if (item.profile?.info_bio && item.profile?.info_bio !== '') completion += 20;
                return (
                    <div className="d-flex ssm-column ai-center border-bottom py-3 user-mgt-list" key={`user-${item.id}`}>
                        <div className="d-h-between d-flex-4 w-100 pb-0 ssp-b-3">
                            <div className="d-flex ai-center cursor-pointer" onClick={() => onSelect(item)('edit')}>
                                <Avatar url={isBanded ? '/images/band-icon.png' : item.avatar} />
                                <span className="dsl-b14 word-break-w text-400 ms-2 me-2">{name}</span>
                            </div>
                            <EditDropdown className="mobile-screen" options={options} onChange={onSelect(item)} />
                        </div>
                        <div className="d-flex-4 w-100 ps-0 text-end cursor-pointer ssm-left ssp-l-3 d-flex jc-end ssm-jc-start" onClick={() => onSelect(item)('settings')}>
                            <label className="dsl-b14 mobile-screen w-50">Default Company</label>
                            <span className="dsl-b14 text-400 word-break-w w-sm-50">{isBanded ? '' : item.profile?.company}</span>
                        </div>
                        <div className="d-flex-3 text-end cursor-pointer ssm-left w-100 ps-0 ssp-l-3" onClick={() => onSelect(item)('settings')}>
                            <label className="dsl-b14 mobile-screen w-50">Profile Optimized</label>
                            <span className="dsl-b14 text-400">{isBanded ? 'NA' : completion}</span>
                        </div>
                        <div className="d-flex-2 text-end ssm-left w-100 ps-0 ssp-l-3">
                            <label className="dsl-b14 mobile-screen w-50">HCM</label>
                            <span className="dsl-b14 text-400">{isBanded ? '' : `${item.hcm_user ? 'Yes' : 'No'}`}</span>
                        </div>
                        <div className="d-flex-3 text-end ssm-left w-100 ps-0 ssp-l-3">
                            <label className="dsl-b14 mobile-screen w-50">Active Login</label>
                            <span className="dsl-b14 text-400">{item.activelogin}</span>
                        </div>
                        <div className="d-flex-3 text-end ssm-left w-100 ps-0 ssp-l-3">
                            <label className="dsl-b14 mobile-screen w-50">Last Login</label>
                            <span className="dsl-b14 text-400">{moment.unix(item.last_active).format('MMM D, YY')}</span>
                        </div>
                        <div className="w50 desktop-screen">
                            <EditDropdown options={options} onChange={onSelect(item)} />
                        </div>
                    </div>
                );
            })}
            <Pagination current={users.current_page} total={users.last_page} per={users.per_page} pers={[]} onChange={handlePage} />
        </>
    );
};

All.propTypes = {
    users: PropTypes.shape({
        current_page: PropTypes.number,
        data: PropTypes.array,
        last_page: PropTypes.number,
        per_page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        from: PropTypes.number,
        to: PropTypes.number,
        total: PropTypes.number,
    }),
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
};

All.defaultProps = {
    users: {
        current_page: 0,
        data: [],
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
    onChange: () => {},
    onSelect: () => {},
};

export default All;
